import {
  AddButton,
  MediumScreenModel,
} from "components";
import { useEffect, useState } from "react";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { connect } from "react-redux";
import { TableColumns } from "./components/TableColumns";
import { fetchCommercialUsers } from "../state/action";
import HandleCreateCommercialUser from "./manage_commercial_user/HandleCreateUser";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';
import ServerTable from "components/table/ServerTable";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const CommercialUserTable: React.FC<Props> = ({
  fetchCommercialUsers,
  onFetchCommercialUsers,
  // onResetCommercialData
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0)
  const [hasNext] = useState(true);
  const openModal = () => setModalOpen(true);
  const [pageIndex, setPageIndex] = useState(0); 
  const commercialUserData = fetchCommercialUsers?.commercialUsers;
  useEffect(() => {
    onFetchCommercialUsers(limit, offset);
  }, [onFetchCommercialUsers, limit, offset]);

  const handlePaginationChange = (newLimit: number, newOffset: number) => {
  const newPageIndex = Math.floor(newOffset / newLimit);
  setLimit(newLimit);
  setOffset(newOffset);
  setPageIndex(newPageIndex);
  onFetchCommercialUsers(newLimit, newOffset);
};
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_COMMERCIAL_USER));
  return (
    <>
      <ServerTable
        headers={["User Management", "Commercial Users"]}
        data={commercialUserData}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <>
            {isPermitted && (
              <AddButton
                onClick={openModal}
                label="Add Commercial User"
                tooltip=""
              />
            )}
          </>
        }
        onPaginationChange={handlePaginationChange} 
        pageIndex={pageIndex}
        pageSize={limit}   
        hasNext={hasNext} 
      />
      {isModalOpen && (
        <MediumScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
          <HandleCreateCommercialUser onClose={() => setModalOpen(false)} />
        </MediumScreenModel>
      )}
    </>
);
};
const mapStateToProps = (state: any) => {
  return {
    fetchCommercialUsers: state.commercialUser.commercialUserState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchCommercialUsers: (limit:number, offset:number) => dispatch(fetchCommercialUsers(limit, offset)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommercialUserTable);
